import { render, staticRenderFns } from "./RoomObjectMenu.vue?vue&type=template&id=a096ed50&scoped=true"
import script from "./RoomObjectMenu.vue?vue&type=script&lang=ts"
export * from "./RoomObjectMenu.vue?vue&type=script&lang=ts"
import style0 from "./RoomObjectMenu.vue?vue&type=style&index=0&id=a096ed50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a096ed50",
  null
  
)

export default component.exports